<template>
  <div>
    <div class="row">
      <div class="col-12 pt-3">
        <SectionTitle has-line content="Alternativa de Ubicación" />
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-4">
        <ValidationProvider
          name="Nombre de alternativa"
          v-slot="{ errors, validate: _validate }"
          mode="passive"
          :disabled="!validate"
          :rules="{ required: true }"
          :custom-messages="{
            required: 'El nombre de alternativa es requerido.',
          }"
        >
          <CustomDropDown
            v-model="model.alternativeLocationCategory"
            :disabled="readonly"
            label="Nombre de Alternativa:"
            fieldkey="id"
            fieldname="name"
            placeholder="Seleccione"
            :options="collections.alternativeLocationCategories"
            :error="errors[0]"
            :custom-error-msg="errors[0]"
            @input="_validate($event !== null || true)"
          />
        </ValidationProvider>
      </div>

      <div class="col-12 col-md-4">
        <ValidationProvider
          name="Cantidad de estudiantes"
          v-slot="{ errors, validate: _validate }"
          mode="passive"
          :disabled="!validate"
          :rules="{ required: true }"
          :custom-messages="{
            required: 'La cantidad de estudiantes es requerida.',
          }"
        >
          <CustomDropDown
            v-model="model.numberOfStudents"
            :disabled="readonly"
            label="Cantidad de Estudiantes:"
            fieldkey="id"
            fieldname="name"
            placeholder="Seleccione"
            :options="collections.numberOfStudents"
            :error="errors[0]"
            :custom-error-msg="errors[0]"
            @input="_validate($event !== null || true)"
          />
        </ValidationProvider>
      </div>

      <div class="col-12 col-md-4">
        <ValidationProvider
          name="Grado"
          v-slot="{ errors, validate: _validate }"
          mode="passive"
          :disabled="!validate"
          :rules="{ required: true }"
          :custom-messages="{
            required: 'El grado es requerido.',
          }"
        >
          <CustomDropDown
            v-model="model.grade"
            :disabled="readonly"
            label="Grado:"
            fieldkey="id"
            fieldname="name"
            placeholder="Seleccione"
            :options="collections.schoolGrades"
            :error="errors[0]"
            :custom-error-msg="errors[0]"
            @input="_validate($event !== null || true)"
          />
        </ValidationProvider>
      </div>

      <div class="col-12 pt-md-3">
        <ValidationProvider
          name="Comentario (alternativa de ubicación)"
          v-slot="{ errors, validate: _validate }"
          :disabled="!validate"
          mode="passive"
          :rules="{ required: true }"
          :custom-messages="{
            required: 'Favor agregar un comentario.',
          }"
        >
          <label class="input-label">Comentario:</label>
          <CustomTextArea
            v-model="model.comment"
            :disabled="readonly"
            :maxlength="3000"
            show-char-count
            :count-classes="['d-block text-right']"
            :error="errors[0]"
            :custom-error-msg="errors[0]"
            @input="_validate($event !== null || true)"
          />
        </ValidationProvider>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomDropDown from 'custom-drop-down';
import CustomTextArea from 'CustomTextArea';

export default {
  name: 'LocationAlternative',
  components: { SectionTitle, CustomDropDown, CustomTextArea },
  props: {
    collections: {
      type: Object,
      default: () => ({
        alternativeLocations: [],
        numberOfStudents: [],
        schoolGrades: [],
      }),
    },
    readonly: { type: Boolean, default: false },
    validate: { type: Boolean, default: false },
    value: {
      type: Object,
      default: () => ({
        alternativeLocationCategory: null,
        numberOfStudents: null,
        comment: null,
        grade: null,
      }),
    },
  },
  data() {
    return {};
  },
  computed: {
    model() {
      return this.value;
    },
  },
};
</script>
